import * as React from 'react';
import { useOpenDocumentWorkspaceEvidenceCitation, getOpenDocumentWorkspaceEvidenceCitationQueryKey, type AgentSource } from '@cdf/api-client-react';
import { useTenantEntity } from '@/components/access/tenant-entity-provider';
import { Button } from '@/components/ui/button';
import { getErrorMessage } from '@/lib/utils';

export function WorkspaceAgentCitation({ source }: { source: AgentSource }) {
  const access = useTenantEntity();
  const boundary = [access.selected?.tenantId, access.selected?.entityId].join(':');
  return <ScopedCitation key={boundary + source.id} source={source} boundary={boundary} />;
}
function ScopedCitation({ source, boundary }: { source: AgentSource; boundary: string }) {
  const [open, setOpen] = React.useState(false);
  const binding = source.workspaceContext;
  const citationId = source.deepLink?.match(/\/citations\/([0-9a-f-]{36})$/i)?.[1] ?? '';
  const workspaceId = binding?.workspaceId ?? '', snapshotId = binding?.snapshotId ?? '';
  const query = useOpenDocumentWorkspaceEvidenceCitation(workspaceId, snapshotId, citationId, { query: { queryKey: [...getOpenDocumentWorkspaceEvidenceCitationQueryKey(workspaceId, snapshotId, citationId), boundary], enabled: Boolean(open && binding && citationId), retry: false, staleTime: 0, gcTime: 0 } });
  return <div className="rounded-md border p-2 text-xs">
    <Button variant="link" size="sm" disabled={!binding || !citationId} onClick={() => { setOpen(true); if (open) void query.refetch(); }}>[{source.citation}] {source.tier} · {source.label}</Button>
    <p>{source.location} · version {source.sourceVersion}</p>
    {open && query.isFetching && <p role="status">Checking citation access…</p>}
    {open && query.isError && <p role="alert">{getErrorMessage(query.error)}</p>}
    {open && !query.isFetching && !query.isError && query.data && <><p className="whitespace-pre-wrap">{query.data.passage.excerpt}</p><p className="mt-1 break-all">Hash {query.data.passage.contentHash}</p></>}
  </div>;
}
